import BrandingOffers from "./BrandingOffers";

const Branding = () => {
  return (
    <section className="solution-item-page">
      <BrandingOffers />
    </section>
  ); 
};

export default Branding;
